<div class="rebox">
    <h3>检测到您的流量异常</h3>
    <br />
    <h4>请点击下方按钮确保您不是机器人</h4>
    <br />
    <div>
        <button class="g-recaptcha" [attr.data-sitekey]="publickKey" data-callback='onValidateCallback' data-action='submit'>提交</button>
    </div>

</div>